module.exports = __webpack_public_path__ + "img/vi.4bc2a560.svg";